/**
 * Shared render helpers for inline multiselect (API and static paths).
 * Ensures identical chip look and behavior including delete icon.
 * Chip border uses isBordered which applies chipBorderd (0.5px solid grey[200]) per Figma.
 */

import { Chip } from 'components';

type OptionWithLabel = { id?: number | string; label?: string };

/**
 * MUI Autocomplete renderTags implementation for inline multiselect.
 * Spreads getTagProps last so onDelete and other MUI props are never overridden.
 */
export function renderMultiselectTags(
  tagValue: OptionWithLabel[],
  getTagProps: (params: { index: number }) => { key: string | number; [key: string]: unknown }
) {
  return tagValue.map((option, index) => {
    const { key, sx: tagSx, ...tagProps } = getTagProps({ index });
    return (
      <Chip
        key={key}
        label={option.label}
        size="sm"
        color="white"
        isBordered
        isTooltip={false}
        sx={tagSx as Record<string, unknown>}
        {...tagProps}
      />
    );
  });
}
